import { NotFoundPage } from '#packages/web/layouts/page/templates';
import { Message } from '#packages/web/foundations/feedback/message';

import { NestedPageLayout } from '../components/nested-page-layout';

export const RouteNotFoundPage = () => (
  <NestedPageLayout title="Page Not Found">
    <NotFoundPage
      message={<Message>The page you are looking for does not exist.</Message>}
    />
  </NestedPageLayout>
);
